import { STORY } from "../../data/content";
import { Reveal, Eyebrow } from "./Reveal";

export default function Story() {
  return (
    <section
      id="story"
      data-testid="story-section"
      className="border-b border-[var(--line)]"
    >
      <div className="mx-auto max-w-[1400px] px-6 pt-28 md:px-10 md:pt-40">
        <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
          <div className="max-w-2xl">
            <Reveal>
              <Eyebrow testid="story-eyebrow">{STORY.eyebrow}</Eyebrow>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="mt-7 font-display text-4xl font-light tracking-tight text-[#1c2b4a] md:text-5xl lg:text-6xl">
                {STORY.heading}
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.15}>
            <span className="font-mono text-[11px] uppercase tracking-[0.24em] text-[#5c6474]">
              05 Reinventions — Scroll →
            </span>
          </Reveal>
        </div>
      </div>

      {/* Horizontal ledger carousel */}
      <div className="pb-28 pt-16 md:pb-40">
        <div className="story-scroll flex snap-x snap-mandatory gap-6 overflow-x-auto px-6 md:px-10 lg:px-[max(2.5rem,calc((100vw-1400px)/2+2.5rem))]">
          {STORY.chapters.map((c, i) => (
            <Reveal key={c.no} delay={i * 0.06} className="shrink-0 snap-start">
              <article
                data-testid={`story-chapter-${c.no}`}
                className="group relative flex h-full w-[300px] flex-col overflow-hidden rounded-sm border border-[var(--line)] bg-white p-8 transition-colors duration-500 hover:border-[#9c7a33]/50 md:w-[370px] md:p-10"
              >
                <span className="pointer-events-none absolute -right-3 -top-7 font-display text-[7.5rem] leading-none text-[#1c2b4a]/[0.06] transition-colors duration-500 group-hover:text-[#9c7a33]/25">
                  {c.no}
                </span>
                <span className="font-mono text-[11px] uppercase tracking-[0.24em] text-[#9c7a33]">
                  Reinvention {c.no}
                </span>
                <h3 className="mt-6 font-display text-3xl leading-tight text-[#1c2b4a]">
                  {c.title}
                </h3>
                <p className="mt-5 font-display text-lg italic leading-snug text-[#9c7a33]">
                  {c.lead}
                </p>
                <p className="mt-4 text-sm leading-relaxed text-[#5c6474] md:text-base">
                  {c.body}
                </p>
                <span className="mt-8 flex items-center gap-3 border-t border-[var(--line)] pt-5 font-mono text-[10px] uppercase tracking-[0.2em] text-[#5c6474]">
                  <span className="h-1.5 w-1.5 border border-[#9c7a33] transition-colors duration-500 group-hover:bg-[#9c7a33]" />
                  Chapter {c.no} / 05
                </span>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
